import { useTranslation } from "react-i18next";
import React, { ChangeEvent, FunctionComponent, KeyboardEvent, useState } from 'react';
import { Button, Col, Dropdown, Input, MenuProps, Modal, Progress, Row, Space, Typography, Upload, UploadProps, message } from 'antd';
import { DownOutlined, LoadingOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import FormInput from '../../../../../components/form-input/FormInput';
import './filter-table.scss';
import { useAuthStore } from '../../../../../stores/stores';
import { BASE_URL_V2 } from '../../../../../config/api/configApiv2';

type FilterTableProps = {
  handleOpen: () => void,
  searchValue: string,
  isRendering: boolean,
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void,
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void,
  handleSubmitSearch: () => void,
  handleOpenFilter: () => void,
}

const FilterTable: FunctionComponent<FilterTableProps> = ({
  handleOpen,
  searchValue,
  isRendering,
  handleChangeInput,
  handleSearch,
  handleSubmitSearch,
  handleOpenFilter,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="filter-table-academic-level">
        <div className="heading-item heading-filter">
          <Button className="filter-button" onClick={handleOpenFilter}>
            <Typography.Text> {t('Bộ lọc', 'Bộ lọc')} </Typography.Text>
            <DownOutlined />
          </Button>
        </div>
        <div className="heading-item heading-search">
          <FormInput placeholder={t("Nhập tên để tìm kiếm", "Nhập tên để tìm kiếm")} value={searchValue}
            onChange={handleChangeInput} onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />} />
        </div>
        <div className="heading-item heading-resigter">
          <Button className='btn-add-new' onClick={handleOpen}>
            <Space> {t("Thêm mới", "Thêm mới")} <PlusOutlined /> </Space>
          </Button>
        </div>
      </div>
    </>
  );
};

export default FilterTable;
